import { EnvironmentProviders, Provider } from '@angular/core';

import { ANALYTICS_ADAPTER_TOKEN, ConsoleLogAnalyticsAdapter, GtmAnalyticsAdapter, provideAnalytics } from '@customer-portal/shared/analytics';
import { isDevelopment } from '@customer-portal/utils';

export function provideAnalyticsConfig(): (Provider | EnvironmentProviders)[] {
  return [
    {
      provide: ANALYTICS_ADAPTER_TOKEN,
      useClass: isDevelopment() ? ConsoleLogAnalyticsAdapter : GtmAnalyticsAdapter,
    },
    ...provideAnalytics(),
  ];
}
